// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"33b19471","387":"9757a198","740":"29655a3a"}[chunkId] + ".chunk.css";
};